/* JELAANCA — Scroll-Reveal, Counter, Sticky-Bar, AJAX-Warenkorb */
(function () {
  document.documentElement.classList.add('jl-js');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll-Reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.jl-reveal');
    if (!('IntersectionObserver' in window) || reducedMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Zähler-Animation ---------- */
  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-jl-count'), 10);
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-jl-suffix') || '';
    var prefix = el.getAttribute('data-jl-prefix') || '';
    if (reducedMotion) {
      el.textContent = prefix + target.toLocaleString('de-DE') + suffix;
      return;
    }
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(target * eased).toLocaleString('de-DE') + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-jl-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(animateCount);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky-Buy-Bar ---------- */
  function initStickyBar() {
    var bar = document.querySelector('.jl-sticky-bar');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-jl-threshold'), 10) || 600;
    var ticking = false;
    function update() {
      var nearBottom =
        window.innerHeight + window.scrollY > document.body.offsetHeight - 200;
      bar.classList.toggle('is-active', window.scrollY > threshold && !nearBottom);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* ---------- AJAX Add-to-Cart (nutzt Dawns Cart-Drawer) ---------- */
  function initAtcForms() {
    document.querySelectorAll('form[data-jl-atc]').forEach(function (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        var addUrl =
          (window.routes && window.routes.cart_add_url) || '/cart/add';
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

        if (btn) btn.setAttribute('aria-busy', 'true');

        var formData = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript'
          },
          body: formData
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200) {
              window.location.href = cartUrl;
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(function () {
            window.location.href = cartUrl;
          })
          .finally(function () {
            if (btn) btn.removeAttribute('aria-busy');
          });
      });
    });
  }

  function init() {
    initReveal();
    initCounters();
    initStickyBar();
    initAtcForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Im Theme-Editor: Sektionen neu initialisieren, wenn Shopify sie neu lädt */
  document.addEventListener('shopify:section:load', init);
})();
